var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("clearance.response.title")) + " ")]), _vm.value.subTotal ? _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.$t("components.ClearanceResponseCard.subtitle", {
    companyName: _vm.partner.companyName
  })) + " ")]) : _vm._e(), _c('div', {
    staticClass: "mx-4 font-weight-black"
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.subTotal || 0, _vm.value.currency)) + " ")]), _c('m-expansion', {
    staticClass: "mx-4",
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t("components.ClearanceResponseCard.repair")) + " ")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showRepairInformation,
      callback: function callback($$v) {
        _vm.showRepairInformation = $$v;
      },
      expression: "showRepairInformation"
    }
  }, [_vm.value.repairStart || _vm.value.repairEnd ? _c('v-card', {
    attrs: {
      "flat": "",
      "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    }
  }, [_c('v-card-text', [_c('v-row', {
    staticClass: "align-center",
    attrs: {
      "justify": "space-between",
      "dense": "",
      "no-gutters": ""
    }
  }, [_c('v-col', [_vm._v(" " + _vm._s(_vm.$t("components.ClearanceResponseCard.addedRepairInfo")) + " ")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('m-icon-button', {
    staticClass: "ma-2",
    attrs: {
      "small": "",
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        _vm.showConfirmDialog = true;
      }
    }
  })], 1)], 1)], 1), _c('v-row', {
    staticClass: "mx-4",
    attrs: {
      "dense": "",
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.clearance.repairStart'),
      "value": _vm.repairStartDisplay
    }
  })], 1), _c('v-col', [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.clearance.repairEnd'),
      "value": _vm.repairEndDisplay
    }
  })], 1)], 1)], 1) : _c('m-no-content', {
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('v-btn', {
          attrs: {
            "outlined": ""
          },
          on: {
            "click": function click($event) {
              _vm.showConfirmDialog = true;
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("components.ClearanceResponseCard.addRepairInfo")) + " ")])];
      },
      proxy: true
    }])
  })], 1), _c('m-expansion', {
    staticClass: "mx-4",
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t("components.ClearanceResponseCard.completionImages")) + " ")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showCompletionImages,
      callback: function callback($$v) {
        _vm.showCompletionImages = $$v;
      },
      expression: "showCompletionImages"
    }
  }, [_vm.value.images && _vm.value.images.length ? _c('v-card', {
    staticClass: "mb-4",
    attrs: {
      "flat": "",
      "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    }
  }, [_c('v-card-text', [_c('v-row', {
    staticClass: "align-center",
    attrs: {
      "justify": "space-between",
      "dense": "",
      "no-gutters": ""
    }
  }, [_c('v-col', [_vm._v(" " + _vm._s(_vm.$t("components.ClearanceResponseCard.addedImages")) + " ")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('m-icon-button', {
    staticClass: "ma-2",
    attrs: {
      "small": "",
      "icon": "mdi-plus",
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        _vm.showImageDialog = true;
      }
    }
  })], 1)], 1), _c('vue-picture-swipe', {
    ref: "pictureSwipe",
    attrs: {
      "items": _vm.mapToImage,
      "options": {
        shareEl: false,
        rotationOn: true
      }
    }
  })], 1)], 1) : _c('m-no-content', {
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('v-btn', {
          attrs: {
            "outlined": ""
          },
          on: {
            "click": function click($event) {
              _vm.showImageDialog = true;
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("components.ClearanceResponseCard.addCompletionImages")) + " ")])];
      },
      proxy: true
    }])
  })], 1)], 1), _vm.showConfirmDialog ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.showConfirmDialog,
      "title": _vm.$t('components.ClearanceResponseCard.addRepairInfo'),
      "leftBtnText": _vm.$t('cancel'),
      "rightBtnText": _vm.$t('confirm'),
      "rightColor": 'primary',
      "loading": _vm.loading,
      "rightLoading": _vm.loading,
      "supressKeyboardActions": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.showConfirmDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.showConfirmDialog = $event;
      },
      "close": function close($event) {
        _vm.showConfirmDialog = false;
      },
      "leftClick": function leftClick($event) {
        _vm.showConfirmDialog = false;
      },
      "rightClick": _vm.confirmClearanceResponse
    }
  }, [_c('v-form', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.clearance.repairStart'),
      "hint": _vm.$t('objects.clearance.repairStartHint'),
      "type": "date",
      "persistent-hint": "",
      "outlined": "",
      "clearable": "",
      "prepend-inner-icon": "mdi-calendar-start"
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.dto.repairStart = null;
      }
    },
    model: {
      value: _vm.dto.repairStartFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.dto, "repairStartFormable", $$v);
      },
      expression: "dto.repairStartFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.endDateRules,
      "label": _vm.$t('objects.clearance.repairEnd'),
      "hint": _vm.$t('objects.clearance.repairEndHint'),
      "type": "date",
      "persistent-hint": "",
      "outlined": "",
      "clearable": "",
      "prepend-inner-icon": "mdi-calendar-end"
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.dto.repairEnd = null;
      }
    },
    model: {
      value: _vm.dto.repairEndFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.dto, "repairEndFormable", $$v);
      },
      expression: "dto.repairEndFormable"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm.showImageDialog ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.showImageDialog,
      "title": _vm.$t('components.ClearanceResponseCard.addCompletionImages'),
      "leftBtnText": _vm.$t('cancel'),
      "rightBtnText": _vm.$t('confirm'),
      "rightColor": 'primary',
      "loading": _vm.loading,
      "rightLoading": _vm.loading,
      "supressKeyboardActions": true,
      "rightDisabled": !_vm.isImageAddingValid,
      "width": 1200,
      "height": 900
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.showImageDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.showImageDialog = $event;
      },
      "close": function close($event) {
        _vm.showImageDialog = false;
      },
      "leftClick": function leftClick($event) {
        _vm.showImageDialog = false;
      },
      "rightClick": _vm.confirmClearanceResponse
    }
  }, [_c('report-image-upload', {
    staticClass: "mt-6",
    attrs: {
      "asset": _vm.asset,
      "example": _vm.example,
      "instruction": _vm.instruction,
      "type": _vm.type,
      "textAlt": "report.additionalImage.textBtnAlt"
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }